
<b-modal
    id="addList"
    title="Lägg till förkortningslista"
    hide-footer
    no-fade
    ref="addlistmodal"
>
    <b-form @submit="onSubmit" autocomplete="off">
        <b-form-group
            id="list-name"
            label-for="list-name-input"
            description="Förkortningslistans namn"
        >
            <b-form-input
                v-model="form.name"
                id="list-name-input"
                required
                autofocus
                :max-length="20"
                placeholder="Ge förkortningslistan ett namn..."
            />
        </b-form-group>
        <b-row>
            <b-col cols="7">
                Ämneslista
                <b-form-checkbox
                    v-model="form.standard"
                    inline
                    name="standard-switch"
                    switch
                >
                    Standardlista
                </b-form-checkbox>
            </b-col>
            <b-col>
                <b-button variant="danger" @click="closeModal">
                    Avbryt
                </b-button>
                <b-button type="submit" variant="primary">
                    Lägg till
                </b-button>
            </b-col>
        </b-row>
    </b-form>
</b-modal>
